import { isDevelop } from "Data/Utils/System";
import { getFeatureFlags, toggleFeature } from "Data/Utils/Features";

export const featureFlags = getFeatureFlags(isDevelop);

export const toggleFeatureRenderer = toggleFeature(featureFlags);
